import { render, staticRenderFns } from "./PayResult.vue?vue&type=template&id=11af73d4&scoped=true"
import script from "./PayResult.vue?vue&type=script&lang=js"
export * from "./PayResult.vue?vue&type=script&lang=js"
import style0 from "./PayResult.vue?vue&type=style&index=0&id=11af73d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11af73d4",
  null
  
)

export default component.exports